import React from 'react';
import CheckBox from '../../../../shared/components/CheckBox';
import { CheckValue } from '../../../../services/types/Misc';

interface Props {
  checkValues: CheckValue[];
  handleChange: (id: string, value: boolean) => void;
}

const CheckboxList = (props: Props) => {
  const { checkValues, handleChange } = props;
  const languageCheck = (element: CheckValue) => (
    <CheckBox
      key={`cb_${element.id}`}
      element={{ ...element, htmlId: `cb_${element.id}` }}
      onChange={handleChange}
    />
  );
  return <>{checkValues.map((c) => languageCheck(c))}</>;
};

export default CheckboxList;
